import React from 'react';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { Grid, KeyValue } from 'web-library';
import DocumentBadge from '../../../../../components/DocumentBadge';
import { MedicalConditionModel } from '../../../../../api/candidate/access-arrangement/model';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  subheader: {
    marginBottom: theme.spacing(4),
  },
  keyValueContainer: {
    marginTop: theme.spacing(2),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
  contentTemplateChildContainer: {
    marginBottom: theme.spacing(4),
  },
}));

interface ReviewMedicalConditionReasonProps {
  medicalConditionLabel: string;
  reasonLabel: string;
  documentLabel: string;
  medicalConditionModel: MedicalConditionModel;
  requiredField?: boolean;
}

const ReviewMedicalConditionReason = ({
  medicalConditionLabel,
  reasonLabel,
  documentLabel,
  medicalConditionModel,
  requiredField = true,
}: ReviewMedicalConditionReasonProps) => {
  const { classes } = useStyles();

  const medicalConditionString = medicalConditionModel.medicalConditionDropdownModel.medicalConditions
    .map((medicalCondition) => medicalCondition.name)
    .join(', ');

  return (
    <Grid className={classes.contentTemplateChildContainer}>
      {(requiredField || medicalConditionString) && (
        <Grid className={classes.keyValueContainer}>
          <KeyValue
            id="medical-condition"
            keyText={medicalConditionLabel}
            valueText={medicalConditionString}
            capitalize={false}
          />
        </Grid>
      )}
      {medicalConditionModel.medicalConditionDropdownModel.remarks && (
        <Grid className={classes.keyValueContainer}>
          <KeyValue
            id="medical-condition-reason"
            keyText={reasonLabel}
            valueText={medicalConditionModel.medicalConditionDropdownModel?.remarks}
          />
        </Grid>
      )}
      {(requiredField || medicalConditionModel.fileAttachedInfoModel.length > 0) && (
        <Grid className={classes.keyValueContainer}>
          <KeyValue
            id="medical-condition-document"
            keyText={documentLabel}
            valueText={
              <Grid className={classes.documentsContainer}>
                {medicalConditionModel.fileAttachedInfoModel.map((document, index) => (
                  <DocumentBadge
                    key={document.fileUuid}
                    className={index !== 0 ? classes.documentBadgeContainer : ''}
                    documentName={document.fileName}
                  />
                ))}
              </Grid>
            }
          />
        </Grid>
      )}
    </Grid>
  );
};

export default ReviewMedicalConditionReason;
